<template>
	<Modal @close="$emit('close')">
		<span slot="title">Change Password</span>
		<div slot="body">
			<div class="field is-maxed">
				<label class="label">Current Password</label>
				<p class="control has-icons-left is-expanded">
					<input class="input is-small "  
						@change="checkCurrentPassword" :class="{'is-danger': errors.currentPassword}"
						v-model.trim="currentPassword"
						type="password" placeholder="Password">
					<span class="icon is-small is-left">
					<i class="fa fa-lock"></i>
					</span>
				</p>
			</div>
			<p class="help is-danger" v-if="errors.currentPassword">
				{{ errors.currentPassword }}
			</p>
			<div class="field is-maxed">
				<label class="label">New Password</label>
				<p class="control has-icons-left is-expanded">
					<input class="input is-small "  
						@change="checkNewPassword" :class="{'is-danger': errors.newPassword}"
						v-model.trim="newPassword"
						type="password" placeholder="Password">
					<span class="icon is-small is-left">
					<i class="fa fa-lock"></i>
					</span>
				</p>
			</div>
			<p class="help is-danger" v-if="errors.newPassword">
				{{ errors.newPassword }}
			</p>
			<div class="field is-maxed">
				<label class="label">Confirm New Password</label>
				<p class="control has-icons-left is-expanded">
					<input class="input is-small "  
						@change="checkConfirmPassword" :class="{'is-danger': errors.confirmPassword}"
						v-model.trim="confirmPassword"
						type="password" placeholder="Password">
					<span class="icon is-small is-left">
					<i class="fa fa-lock"></i>
					</span>
				</p>
			</div>
			<p class="help is-danger" v-if="errors.confirmPassword">
				{{ errors.confirmPassword }}
			</p>
		</div>
		<div class="field is-grouped" slot="footer">
			<div class="control">
				<a class="button is-small is-primary" @click="savePassword()"><i class="fa fa-check"></i></a>
			</div>
			<div class="control">
				<a class="button is-small is-danger" @click="$emit('close')"><i class="fa fa-remove"></i></a>
			</div>
		</div>
	</Modal>
</template>

<script>
	import Modal from "../Modal.vue"
	
	export default {
		components: {
			Modal,
		},
		data() {
			return {
				newPassword: "",
				currentPassword: "",
				confirmPassword: "",
				errors: {
					newPassword: null,
					confirmPassword: null,
					currentPassword: null
				}
			}
		},
		methods: {
			checkCurrentPassword() {
				this.errors.currentPassword = null
				if (this.currentPassword === "") {
					this.errors.currentPassword = "Password is required"
				} else if (this.currentPassword.length < 6 || this.currentPassword.length > 50) {
					this.errors.currentPassword = "Password is invalid"
				}

				return this.errors.newPassword === null
			},
			checkNewPassword() {
				this.errors.newPassword = null
				if (this.newPassword === "") {
					this.errors.newPassword = "Password is required"
				} else if (this.newPassword.length < 6 || this.newPassword.length > 50) {
					this.errors.newPassword = "Password is invalid"
				}

				return this.errors.newPassword === null
			},
			checkConfirmPassword() {
				this.errors.confirmPassword = null
				if (this.confirmPassword === "") {
					this.errors.confirmPassword = "Password Confirmation is required"
				} else if (this.confirmPassword !== this.newPassword) {
					this.errors.confirmPassword = "Passwords do not match"
				}

				return this.errors.confirmPassword === null
			},
			async savePassword() {
				if (this.checkCurrentPassword() && this.checkNewPassword() && this.checkConfirmPassword()) {
					try {
						await this.$root.$data.setters.updatePassword(this.$root.$data.state, {
							password: this.newPassword,
							old: this.currentPassword
						})
						this.$notify({
							group: 'global',
							type: 'success',
							title: 'Password Updated',
							text: 'Your password has been updated.',
						})
						this.$emit('close')
					} catch (e) {
						if (e.response === 422) {
							this.errors.currentPassword = "Password is not correct"
						} else {
							this.$emit('close')
						}
					}	
					this.newPassword = ""
					this.currentPassword = ""
					this.confirmPassword = ""
				}			
			}
		},
	}
</script>